import img1 from '../images/team/Nataliya.jpg';
import img2 from '../images/team/Mariya.jpg';
import img3 from '../images/team/Andrey.jpeg';
import img4 from '../images/team/Alina.jpg';
import img5 from '../images/team/Sergey.jpg';
import img6 from '../images/team/Uliya.jpg';
import img7 from '../images/team/Yana.jpg';
import img8 from '../images/team/Ihor.jpg';
import img9 from '../images/team/Naira.jpg';
import img10 from '../images/team/Dmitriy.jpg';


export default [
  {
    fullName: 'Natalia Dobrovolskaya',
    position: '• Team lead • Footer markup and styles • Button "UP"',
    photo: `${img1}`,
    Slack: '#',
    facebook: 'https://www.facebook.com/profile.php?id=100012840857670',
    Git: 'https://github.com/Natalia-doobro',
  },
  {
    fullName: 'Mariia Slobozhan',
    position: '• Scrum master • API requests logic for searching events by keyword and country name • First time load page',
    photo: `${img2}`,
    Slack: '#',
    facebook: 'https://www.facebook.com/maryia.slobozhan',
    Git: 'https://github.com/mariia-slobozhan',
  },
  {
    fullName: 'Andrey Galkin',
    position: '• Open/close modal logic • API request for certain event details',
    photo: `${img3}`,
    Slack: '#',
    facebook:'https://www.facebook.com/profile.php?id=100023446086964',
    Git: 'https://github.com/AndrewGalkin',
  },
  {
    fullName: 'Alina Kasianova',
    position: '• Main container styles • Event card styles and animation • Favicon • Theme-switcher logic and styles',
    photo: `${img4}`,
    Slack: '#',
    facebook: '',
    Git: 'https://github.com/AlinaKas',
  },
  {
    fullName: 'Sergey Yakimov',
     position: '• Pagination logic and styles',
    photo: `${img5}`,
    Slack: '#',
    facebook: '',
    Git: 'https://github.com/SerheiYakimov',
  },
  {
    fullName: 'Uliya Kucherenko',
    position: '• Header styles • Title animation',
    photo: `${img6}`,
    Slack: '#',
    facebook: 'https://www.facebook.com/OwlJule',
    Git: 'https://github.com/UliyaKucherernko',
  },
  {
    fullName: 'Yana Yermak',
    position: '• Event card markup • Team modal logic and styles',
    photo: `${img7}`,
    Slack: '#',
    facebook:'https://www.facebook.com/profile.php?id=100003188104881',
    Git: 'https://github.com/ermak-yana',
  },
  {
    fullName: 'Ihor Rudniev',
    position: '• Input styles',
    photo: `${img8}`,
    Slack: '',
    facebook: 'https://www.facebook.com/IhorRudniev',
    Git: 'https://github.com/ihorrudniev',
  },
  {
    fullName: 'Naira Kazeian',
    position: '• Basic styles and variables • Theme-switcher logic and styles',
    photo: `${img9}`,
    Slack: '#',
    facebook: 'https://www.facebook.com/naira.kazeyan',
    Git: 'https://github.com/Naira21',
  },
  {
    fullName: 'Dmitriy Shevchuk',
     position: '• Event modal styles • Buy-tickets-link logic',
    photo: `${img10}`,
    Slack: '#',
    facebook:'https://www.facebook.com/dmitrij.shevchuk.9',
    Git: 'https://github.com/AmbassadorOfHappiness',
  }
];


